import styled from "styled-components";


export const ContainerLista = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    background-color: #E4D7D0;
    min-height: 100vh;
`